import React, { act, useEffect, useState } from 'react';
import 'bootstrap-select';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RunnerEngineService from 'service/RunnerEngineService';
import LoadingSpinner from 'component/LoadingSpinner';
import BooleanSlider from 'component/BooleanSlider';
import { RunnerEngineCreateReq } from 'domain/payload/request/runnerEngine/RunnerEngineCreateReq';
import { RunnerEngineUpdateReq } from 'domain/payload/request/runnerEngine/RunnerEngineUpdateReq';

const RunnerEngineForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const navigate = useNavigate();

  const runnerEngineService = RunnerEngineService();

  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [command, setCommand] = useState('');

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setIsLoadingSave(true)

    try {
      if (id == "0") {
        await RunnerEngineCreate()
        alert(`Data ${name} successfully created!`)
        navigate("/runner-engine")
      } else {
        await RunnerEngineUpdate()
        alert(`Data ${name} successfully updated!`)
        navigate("/runner-engine")
      }
      setIsLoadingSave(false)
    } catch (e) {
      alert(e)
      setIsLoadingSave(false)
    }
  };

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) return;

    setIsLoadingDetail(true)
    try {
      const res = await runnerEngineService.runnerEngineDetail(token, id ?? "0");
      console.log(res)
      setCode(res.data?.code!)
      setName(res.data?.name!)
      setDescription(res.data?.description!)
      setCommand(res.data?.command!)

      setIsLoadingDetail(false)
    } catch (err) {
      console.error(err);
      setIsLoadingDetail(false)
    }
  };

  const RunnerEngineCreate = async () => {
    const token = profile?.data.token;
    if (!token) return;

    try {
      var request: RunnerEngineCreateReq = {
        code: code,
        name: name,
        description: description,
        command: command,
      }

      await runnerEngineService.runnerEngineCreate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  const RunnerEngineUpdate = async () => {
    const token = profile?.data.token;
    if (!token) return;

    try {
      var request: RunnerEngineUpdateReq = {
        id: id!,
        code: code,
        name: name,
        description: description,
        command: command,
      }

      await runnerEngineService.runnerEngineUpdate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  useEffect(() => {
    if (id != "0") {
      fetchDetail()
    }
  }, [])

  return (
    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">{id == "0" ? "Add RunnerEngine" : "Edit RunnerEngine"}</h4>
        <div className="p-4" style={{ background: 'white' }}>

          {
            isLoadingDetail ?
              <LoadingSpinner />
              :
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div>
                      {/* <h5 className="mb-4">Basic Information</h5> */}
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Code</label>
                        <input
                          type="text"
                          id="legalName"
                          className="form-control form-control-compact"
                          value={code}
                          placeholder="Code"
                          onChange={(e) => setCode(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Name</label>
                        <input
                          type="text"
                          id="name"
                          className="form-control form-control-compact"
                          value={name}
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Description</label>
                        <textarea
                          id="description"
                          className="form-control form-control-compact"
                          rows={3}
                          value={description}
                          placeholder="Description"
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                    </div>
                  </div>
                  <div className="mb-5">
                        <label htmlFor="name" className="form-label fw-semibold">Command</label>
                        <textarea
                            id="command"
                            className="form-control form-control-compact"
                            rows={5}
                            value={command}
                            placeholder="Command"
                            onChange={(e) => setCommand(e.target.value)}
                            required
                        />
                    </div>
                </div>

                <div className="w-100 d-flex justify-content-end">
                  <Link to="/runner-engine">
                    <button className="btn btn-outline-primary">Cancel</button>
                  </Link>
                  <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center ms-2" disabled={isLoadingSave}>
                    {
                      isLoadingSave &&
                      <>
                        <LoadingSpinner reverse={true} />
                        <p className="ms-2"></p>
                      </>
                    }
                    Save
                  </button>
                </div>
              </form>
          }
        </div>
      </div>
    </div>
  );

};

export default RunnerEngineForm;